import React, { Fragment } from 'react';
import { Card, CardBody, Col, Container, Row, Button,Input } from 'reactstrap';
import { ModalUnit } from '../../../components/units/ModalUnit';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { useIndicationsPatients } from '../../../hooks/indications/useIndicationsPatients';
import { ModalIndications } from '../../../components/indications/ModalIndications';
import { ModalSendCSV } from '../../../components/indications/ModalSendCSV';
import '../../../views/configuraciones/indications/StyleIndications.css'

export const IndexIndicationsPatients = (props) => {
    const {
        // ?LIST INDICATIONS
        listIndications,
        
        // ?MODAL CREATE INDICATIONS
        method, modal, modalTitle, loading, closeDialog,
        handleCreate, saveCreate, handleUpdate, saveUpdate, handleDelete, saveDelete, validaciones,
        id_exam_indication, indication, handleInputChange,
       
        //? DIALOG SEND CSV
        handleSendCSV, modal2, method2, modalTitle2, toggle2, file,
        handleOnChange, ExamIndication,
        handleSearchIndication,

        // * SEARCH AND DOWNLOAD EXCEL
        handleExcelIndicaionsP, loadingExcel, handleSearchIndicationsP, 
        searchIndicationsP, handleClearIndicationsP,

        //* DELETED DIALOG
        showDeleteAlert, modalAlert, closeDeleteAlert
  
    } = useIndicationsPatients();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "8px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
        lineHeight: "1.8",
        color: "#353535"
    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_exam_indication)}
                    title="Editar"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>


                <button
                    onClick={() => handleDelete(rowData.id_exam_indication)}
                    title="Eliminar"
                    className="btnTableAction"
                    style={{
                        backgroundColor: "#bf0d0d"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    };

    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-1">
                                <TitleDataTable
                                    titleTable="Listado de indicaciones para pacientes"
                                    buttonActions={handleExcelIndicaionsP}
                                    titleButton="Excel de indicaciones"
                                    isDisbled={loadingExcel}
                                    loadingIsDisabled={loadingExcel}
                                    titleCreate="Crear indicación para pacientes"
                                    buttonActionsCreate={handleCreate}
                                    actionInput={handleSearchIndicationsP}
                                    valueFilter={searchIndicationsP}
                                    filterLocalStorage={true}
                                    cleanFilterLocalStorage={handleClearIndicationsP}

                                    uploadButton={true}
                                    buttonUpload={handleSendCSV}
                                    titleButtonUpload="Carga masiva"
                                />

                                <div className="table-responsive">
                                    <DataTable
                                        value={listIndications}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        rowsPerPageOptions={[10, 50, 100]} 
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >
                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column 
                                            field="indication"
                                            header="Indicaciones para el exámen" 
                                            sortable
                                            body={(rowData) => (
                                                <span style={{ fontWeight: "bold" }}>
                                                    {rowData.indication}
                                                </span>
                                            )}
                                            headerStyle={headerStyle} 
                                            style={cellStyle} 
                                        />
    
                                       
                                        
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                    </DataTable>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ModalIndications
            {
                ...{
                    method, modalTitle, loading, modal, closeDialog,
                    saveCreate,handleInputChange,saveUpdate,saveDelete,validaciones,
                    id_exam_indication, indication
                    
                }
            }
            />
            <ModalSendCSV
            {
                ...{
                    modal2, method2, modalTitle2,loading,toggle2,file,handleInputChange,handleOnChange,
                    ExamIndication

                }
            }
            />

            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar la indicación de paciente"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar la indicación del paciente para el examen ?"
                    alert1={true}
                    titleAlert1={indication}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                />
            )}

        </Fragment>
    )
}
